<a
  cgwThrottleTime
  (throttledClick)="onClick()"
  [time]="data.throttleTime ?? 0"
  [disableThrottle]="!data?.throttleTime"
  class="{{ data?.class }} product-card__button cg__button cg__button--{{
    data.type
  }} align-items-center {{ data.title ? 'px-3' : '' }}"
  [class.disabled]="data.disabled">
  @if (data.icon) {
    <span class="material-symbols-outlined"> {{ data.icon }} </span>
  }
  @if (data.title) {
    <span>{{ data.title }}</span>
  }
</a>
